import router from '@/router'
import { collectMenuKey } from '@/components/Layout/constants'

export interface MenuListItem {
  name: string
  routeUrl: string
}

const tablist: MenuListItem[] =
  window.sessionStorage.getItem('tablist') &&
  JSON.parse(window.sessionStorage.getItem('tablist') as any)
const currentTab =
  window.sessionStorage.getItem('currentTab') &&
  JSON.parse(window.sessionStorage.getItem('currentTab') as any)
const menulist: any[] =
  window.localStorage.getItem('menulist') &&
  JSON.parse(window.localStorage.getItem('menulist') as any)
const pagelist: any[] =
  window.localStorage.getItem('pagelist') &&
  JSON.parse(window.localStorage.getItem('pagelist') as any)
const recentVisitList: any[] =
  window.localStorage.getItem('recentVisitList') &&
  JSON.parse(window.localStorage.getItem('recentVisitList') as any)

interface State {
  visible: boolean
  currentMenu: string
  menuList: any[]
  pageList: MenuListItem[]
  tabList: MenuListItem[]
  currentTab: MenuListItem | null
  microApps?: any[]
  recentVisitList: any
  backRoute: any
  menuLoading?: boolean
  /**
   * 收藏菜单
   */
  collectList: any[]
}

const state: State = {
  visible: false,
  currentMenu: '',
  menuList: menulist || [],
  pageList: pagelist || [],
  tabList: tablist || [],
  currentTab: currentTab || null,
  recentVisitList: recentVisitList || [],
  backRoute: null,
  menuLoading: false,
  collectList: JSON.parse(window.localStorage.getItem(collectMenuKey) || '[]')
}

const getter = {}

const mutations = {
  changeVisible(state: State, visible: boolean) {
    state.visible = visible
  },
  changeCurrentMenu(state: State, path: string) {
    state.currentMenu = path
  },
  setMenuList(state: State, menuList: any[]) {
    // state.menuList = []
    // window.localStorage.setItem('menulist', '[]')
    state.menuList = menuList
    window.localStorage.setItem('menulist', JSON.stringify(state.menuList))
  },
  setPageList(state: State, pageList: any[]) {
    // state.pageList = []
    // window.localStorage.setItem('pagelist', '[]')
    state.pageList = pageList
    window.localStorage.setItem('pagelist', JSON.stringify(state.pageList))
  },
  addTabMenu(state: State, item: MenuListItem): void {
    state.tabList.unshift(item)
    window.sessionStorage.setItem('tablist', JSON.stringify(state.tabList))
  },
  changeTabMenu(state: State, indexObj: any) {
    if (indexObj.draggedIndex !== indexObj.index) {
      // 如果拖拽的目标和放置的目标不一致
      const temp = state.tabList[indexObj.draggedIndex] // 临时保存拖拽的标签页数据
      state.tabList.splice(indexObj.draggedIndex, 1) // 移除原位置的标签页数据
      state.tabList.splice(indexObj.index, 0, temp) // 在放置的位置插入拖拽的标签页数据
    }
    window.sessionStorage.setItem('tablist', JSON.stringify(state.tabList))
  },
  setCurrentTab(state: State, item: MenuListItem): void {
    state.currentTab = item
  },
  changeCurrentTab(state: State, item: MenuListItem): void {
    state.currentTab = item
    const tabIndex = state.tabList.findIndex(
      tab => tab.name === item.name || tab.routeUrl.split('?')[0] === item.routeUrl.split('?')[0]
    )
    tabIndex !== -1 && state.tabList.splice(tabIndex, 1, item)
    window.sessionStorage.setItem('currentTab', JSON.stringify(state.currentTab))

    // 添加最近访问
    const currentRouteIndex = state.recentVisitList.findIndex(
      (route: any) => route.routeUrl === item.routeUrl
    )
    if (currentRouteIndex > -1) {
      state.recentVisitList.splice(currentRouteIndex, 1)
    }
    state.recentVisitList.unshift(item)
    state.recentVisitList.splice(8)
    window.localStorage.setItem('recentVisitList', JSON.stringify(state.recentVisitList))
  },
  deleteTab(state: State, name: string, auto = false): void {
    const index = state.tabList.findIndex(item => item.name === name)
    state.tabList.splice(index, 1)
    window.sessionStorage.setItem('tablist', JSON.stringify(state.tabList))
    ;(this as any).commit('microApp/updateMicroCacheList')
  },
  defaultDeleteTab(state: State, name: string): void {
    const index = state.tabList.findIndex(item => item.name === name)

    let nextTabIndex = index + 1
    if (nextTabIndex === state.tabList.length) nextTabIndex = index - 1
    const nextTab = state.tabList[nextTabIndex]
    mutations.changeCurrentTab(state, nextTab)

    router.push(nextTab.routeUrl)

    state.tabList.splice(index, 1)
    window.sessionStorage.setItem('tablist', JSON.stringify(state.tabList))
    ;(this as any).commit('microApp/updateMicroCacheList')
  },
  resetTab(state: State) {
    window.sessionStorage.removeItem('tablist')
    window.sessionStorage.removeItem('currentTab')
    state.tabList = []
    state.currentTab = null
    ;(this as any).commit('microApp/updateMicroCacheList')
  },
  setTab(state: State, items: MenuListItem[]) {
    state.tabList = items
    console.log(items)
    window.sessionStorage.setItem('tablist', JSON.stringify(state.tabList))
    ;(this as any).commit('microApp/updateMicroCacheList')
  },
  setErrorLastRoute(state: State, route: any) {
    state.backRoute = route
  },
  changeMenuLoading(state: State, visible: boolean) {
    state.menuLoading = visible
  },
  /**
   *  添加收藏菜单
   * @param item 收藏菜单item
   */
  addCollect(state: State, item: any) {
    const has = state.collectList.some((i: any) => i.menuId === item.menuId)
    if (has) return state.collectList
    state.collectList = state.collectList.concat([item])
    localStorage.setItem(collectMenuKey, JSON.stringify(state.collectList))
    return state.collectList
  },
  /**
   *  删除收藏菜单
   * @param item 收藏菜单item
   */
  removeCollect(state: State, item: any) {
    const findIndex = state.collectList.findIndex((i: any) => i.menuId === item.menuId)
    if (findIndex === -1) return state.collectList
    state.collectList.splice(findIndex, 1)
    localStorage.setItem(collectMenuKey, JSON.stringify(state.collectList))
    return state.collectList
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  getter,
  mutations,
  actions
}
